import {ChangeDetectorRef, Component,Output, OnDestroy,EventEmitter, OnInit,Input,OnChanges,ChangeDetectionStrategy,ApplicationRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService} from "../../../../node_modules/ng2-translate/src/translate.service";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryService} from "../../services/category/category.service";
import {AlertService} from "../../services/alert/alert.service";
import {AuthService} from "../../services/auth/AuthService";
import {CacheUtilService} from "../../services/cache-util/CacheUtilService";
import {UserVM} from "../../models/UserVM";
import {Subscription} from "rxjs/Subscription";
import {TimerObservable} from "rxjs/observable/TimerObservable";


@Component({
  selector: 'rw-login-form',
  template: require('./login-form.component.html'),
  styles: [require('./login-form.style.css')],
  providers: [CategoryService]

})

export class LoginFormComponent implements OnDestroy, OnInit,OnChanges {
  // @Input() intakeForm:IntakeFormVM = new IntakeFormVM();
   @Output() currentUserChanged = new EventEmitter();
  // requiredFieldExist: boolean = false;
  public vmMobileNumber= ''
  user=null;
  modeMobileNumber= '';
  mobileNumber= null;
  firstName= '';
  lastName= null;
  password= null;
  verificationCode= null;
  email= '';
  isRegisterMode= false;
  isLoginMode= false;
  isVerificationMode= false;
  isPasswordForgottenMode= false;
  isLoggedInMode= false;
  loading= false;
  loggedInUser= null;
  message= null;
  messageMode= null;
  noPasswordMode=true;
  private canResendMessage = false;
  private tick: number = 60;
  private subscription: Subscription;
  public emailTranslateParam = {value: '(اختیاری)'};
  public isEmailRequired:boolean=false;
  public isClientEmailRequired;
  keyUrl="";
  constructor(private ref:ChangeDetectorRef,
              public route:ActivatedRoute,
              public router:Router,
              public translate:TranslateService,
              private authService:AuthService,
              private alertService:AlertService,
              private cacheUtil:CacheUtilService,
              private categoryService:CategoryService,
              private companyService: CompanyService
  ) {
  }
  register () {
    let parent = this;
    parent.loading = true;
    let user = new UserVM();

      user.firstName= parent.firstName;
      user.lastName= parent.lastName;
      user.email= parent.email;
      user.login= parent.mobileNumber;
      user.phoneNumber= parent.mobileNumber;
      user.password= parent.password;

      parent.authService.createAccount(user).then(function (user) {
      parent.login();
      parent.loading = false;
      parent.resetFieldData();
    }).catch(function (e) {
      parent.loading = true;
    });


  }



  checkIsLoggedIn() : void {
    let parent = this;
    parent.loading = true;
    parent.authService.Account().subscribe(function (userInfo) {
      console.log("checkIsLoggedIn");
      parent.loggedInUser = userInfo;
      parent.setLoggedInMode();
     // this.authService.se(userInfo.data);
      parent.loading = false;
      parent.currentUserChanged.emit(parent.loggedInUser);

    });
  }

  checkMobileNumber() : boolean {
    let isValid = true;
    if (this.mobileNumber &&( this.mobileNumber.length < 11 || this.mobileNumber.length > 11 ) ) {
      this.vmMobileNumber = 'invalidMobileNumber';
      isValid = false;
    }


    if (isValid) {
      this.modeMobileNumber = 'is-success';
      this.vmMobileNumber = '';
    }
    else {
      this.modeMobileNumber = 'is-danger';
    }
    return isValid;
  }
 confirmMobileNumber() : void {
   let parent = this;
   if (this.checkMobileNumber()) {
     parent.loading = true;
     parent.authService.tryToSendActivationCode(this.mobileNumber,this.keyUrl, function (result) {
         parent.setVerificationMode();
         parent.startTimer();
         parent.loading = false;
       },
       function (e) {
         parent.loading = false;

         if (e.status == 400) {
           parent.setLoginMode();
         }
       }
     );

   }
 }
  confirmVerificationCode() : void {
    let parent = this;
    if (this.checkMobileNumber()) {
      parent.loading = true;
      parent.authService.confirmActivationCode(this.mobileNumber, this.verificationCode).then(function (result) {
        parent.setRegisterMode();
        parent.loading = false;
        parent.clearMessage();
      }).catch(function (e) {
        parent.loading = false;
        // parent.showErrorMessage('invalidVerificationCode');
      });
    }
  }
  changePassword() : void {
    let parent = this;
    let passwordDTO = new UserVM();
    passwordDTO.password = parent.password;
    passwordDTO.phoneNumber = parent.mobileNumber;
    passwordDTO.verificationCode = parent.verificationCode;

    parent.authService.resetPassword(passwordDTO).then(function () {
      parent.login();
      parent.resetFieldData();
      //  alert('done');
    }).catch(function (response) {
      //    parent.passwordResetDone();
      //alert('error');

    });
  }

  resetFieldData() : void {

    this.verificationCode = "";
    this.firstName = "";
    this.lastName = "";
    this.password = "";

  }

  sendVerificationCodeForPasswordRecovery() : void {
    let parent = this;
    if (this.checkMobileNumber()) {
      parent.loading = true;
      parent.authService.sendActivationCodeToResetPassword(this.mobileNumber,this.keyUrl).then(function (result) {
        parent.setPasswordForgottenMode();
        parent.loading = false;

      }).catch(function (e) {
        parent.loading = false;
      });
    }
  }

  changePhoneNumber() : void {

    this.goToFirstMode();

  }
  goToFirstMode():void{

    this.isLoggedInMode = false;
    this.isLoginMode = false;
    this.isRegisterMode = false;
    this.isVerificationMode = false;
    this.isPasswordForgottenMode = false;

  }

  resendVerificationCode() : void{
    let parent = this;

  }

  startTimer() {
    let parent = this;
    this.canResendMessage = false;
    this.tick = 60;
    if (this.subscription)
      this.subscription.unsubscribe();
    let timer = TimerObservable.create(2000, 1000);
    this.subscription = timer.subscribe(t => {
      if (this.tick > 0) {
        this.tick = this.tick - 1;
      } else {
        this.canResendMessage = true;
      }
    });
  }

  getCompanyInfo() : void {
    let parent = this;

    this.companyService.getCompanyInfo().subscribe((c) => {
      if(c && c.keyUrl)
        parent.keyUrl = c.keyUrl;

      parent.isClientEmailRequired = parent.companyService.getCompanyCustomSetting(c, 'isClientEmailRequired');
      // let el = document.getElementById('email') as HTMLElement;

      if (parent.isClientEmailRequired) {
        parent.isEmailRequired=true;
        this.emailTranslateParam = {value: ''};

        // el.removeAttribute('required');
      }
      if(!parent.email){
        parent.email = '';
      }
    })
  }
  logout() : void {

    let parent = this;
    this.authService.logout();
    parent.loggedInUser = null;
    parent.mobileNumber = null;
    parent.password = null;
    parent.emitUserInfoChanged();
    parent.initMode();
  }
  login() : void {
    let parent = this;
    parent.loading = true;
    let credential= {
      userName: parent.mobileNumber,
      password: parent.password,
    };

    this.authService.login(credential).then(function (result) {

      parent.cacheUtil.storeInCache("jhi-authenticationToken", result);


      parent.authService.loggedIn().then((res)=> {

        parent.setLoggedInMode();
        // this.authService.se(userInfo.data);
        parent.loading = false;
        parent.authService.updateLoginStatus(()=>{
          parent.loggedInUser = parent.authService.currentUser;
          parent.currentUserChanged.emit( parent.loggedInUser );
        });

      });
        parent.password = '';
      parent.loading = false;
      parent.clearMessage();
      parent.emitUserInfoChanged();
    }).catch(function (e) {
      // parent.showErrorMessage('invalidPassword');
      parent.password = '';
      parent.loading = false;
      parent.alertService.showErrorMessage('global.messages.error.failedLogin');
    });

  }
  emitUserInfoChanged() : void {
    this.currentUserChanged.emit(this.loggedInUser)
  }
  setLoginMode() : void {
    this.isRegisterMode = false;
    this.isLoginMode = true;
    this.isVerificationMode = false;
    this.isPasswordForgottenMode = false;
    this.isLoggedInMode = false;

  }
  setRegisterMode() : void {
    this.isRegisterMode = true;
    this.isLoginMode = false;
    this.isVerificationMode = false;
    this.isPasswordForgottenMode = false;
    this.isLoggedInMode = false;
  }
  setVerificationMode() : void {
    this.isRegisterMode = false;
    this.isLoginMode = false;
    this.isVerificationMode = true;
    this.isPasswordForgottenMode = false;
    this.isLoggedInMode = false;
  }
  setPasswordForgottenMode() : void {
    this.isRegisterMode = false;
    this.isLoginMode = false;
    this.isVerificationMode = false;
    this.isPasswordForgottenMode = true;
    this.isLoggedInMode = false;
  }
  setLoggedInMode() : void {
    this.isRegisterMode = false;
    this.isLoginMode = false;
    this.isVerificationMode = false;
    this.isPasswordForgottenMode = false;
    this.isLoggedInMode = true;
  }
  initMode() : void {
    this.isRegisterMode = false;
    this.isLoginMode = false;
    this.isVerificationMode = false;
    this.isPasswordForgottenMode = false;
    this.isLoggedInMode = false;
    let parent=this;
    setTimeout(function(){
      // let refs=parent.$refs;
      // console.log(refs);
      // if(refs.mobilenumberel)
      //   refs.mobilenumberel.focus();
    },5)
  }
  showInfoMessage(m) {
    this.message = m;
    this.messageMode = 'info';
  }
  showErrorMessage(m) {
    this.message = m;
    this.messageMode = 'error';
  }
  clearMessage() : void {
    this.message = '';
    this.messageMode = '';
  }
  t(m) {
return this.translate.instant(m);
  }

  ngOnDestroy():void {
    window.removeEventListener("loggedIn" , this.loggedInEventHandler.bind(this));
    window.removeEventListener("loggedOut" , this.loggedOutEventHandler.bind(this));

  }

  ngOnInit():void {
    window.addEventListener("loggedIn" , this.loggedInEventHandler.bind(this));
    window.addEventListener("loggedOut" , this.loggedOutEventHandler.bind(this));
    this.initMode();
    this.checkIsLoggedIn();
    this.getCompanyInfo();

  }

  loggedInEventHandler():void{
    this.initMode();
    this.checkIsLoggedIn();
  }

  loggedOutEventHandler():void{

    this.loggedInUser = null;
    this.mobileNumber = null;
    this.password = null;
    this.initMode();
  }
  ngOnChanges(changes):void {


  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/login-form/login-form.component.ts